import React, { useState, useEffect } from "react";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import httpRequest from "./HttpService";

const STYLE_CONFIG = {
  info: {
    backgroundColor: "#e3f2fd",
    border: "3px solid #1565c0",
    color: "#000000",
    icon: <InfoIcon style={{ marginRight: "18px", color: "#1565c0", flexShrink: 0, fontSize: "36px" }} />,
  },
  warning: {
    backgroundColor: "#fff3cd",
    border: "1px solid #ffeeba",
    color: "#856404",
    icon: <WarningIcon style={{ marginRight: "18px", color: "#ffc107", flexShrink: 0, fontSize: "36px" }} />,
  },
  error: {
    backgroundColor: "#ffebee",
    border: "3px solid #c62828",
    color: "#000000",
    icon: <ErrorIcon style={{ marginRight: "18px", color: "#c62828", flexShrink: 0, fontSize: "36px" }} />,
  },
  success: {
    backgroundColor: "#e8f5e9",
    border: "3px solid #2e7d32",
    color: "#000000",
    icon: <CheckCircleIcon style={{ marginRight: "18px", color: "#2e7d32", flexShrink: 0, fontSize: "36px" }} />,
  },
};

function NotificationBanner({ sessionToken }) {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!sessionToken) return;
    httpRequest
      .getNotifications()
      .then((body) => {
        if (body.data && body.data.length > 0) {
          setNotifications(body.data);
        }
      })
      .catch(() => {});
  }, [sessionToken]);

  const handleDismiss = (notificationID) => {
    setNotifications((prev) => prev.filter((n) => n.notificationID !== notificationID));
    httpRequest.acknowledgeNotification(notificationID).catch(() => {});
  };

  if (notifications.length === 0) return null;

  return (
    <div style={{ width: "100%" }}>
      {notifications.map((notification) => {
        const styleConfig = STYLE_CONFIG[notification.notificationStyle] || STYLE_CONFIG.info;
        const lines = (notification.noteText || "").split(/\r?\n/);
        return (
          <div key={notification.notificationID} style={{ width: "100%", marginBottom: "4px", paddingLeft: "24px", paddingRight: "440px", boxSizing: "border-box" }}>
            <div style={{
              backgroundColor: styleConfig.backgroundColor,
              border: styleConfig.border,
              borderRadius: "8px",
              padding: "4px 8px",
              display: "flex",
              alignItems: "flex-start",
              color: styleConfig.color,
            }}>
              <div style={{ display: "flex", alignItems: "center", height: "1.76rem", flexShrink: 0 }}>
                {styleConfig.icon}
              </div>
              <div style={{ flexGrow: 1, fontSize: "1.1rem", lineHeight: 1.6, letterSpacing: "0.3px", wordWrap: "break-word", overflowWrap: "break-word" }}>
                {lines.map((line, idx) => (
                  <div key={idx}>{line || " "}</div>
                ))}
              </div>
              <div
                onClick={() => handleDismiss(notification.notificationID)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  cursor: "pointer",
                  flexShrink: 0,
                  marginLeft: "16px",
                  fontSize: "0.9rem",
                  color: styleConfig.color,
                  userSelect: "none",
                }}
              >
                <span>Dismiss</span>
                <span style={{ fontSize: "1.1rem", lineHeight: 1 }}>✕</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default NotificationBanner;
